const getCIDFromUri = {
    getData(queryParam) {
        var query = window.location.href;
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == queryParam) {
                return pair[1];
            }
        }
        return false;
    }
};

export default getCIDFromUri;
